// extracted by mini-css-extract-plugin
export default {"homeVideoContainer":"HomeVideo_homeVideoContainer__aEb9G","homeVideo":"HomeVideo_homeVideo__-7s0k","videoLoading":"HomeVideo_videoLoading__H1lxa"};